import { REQUEST_SIZE } from 'constants/general';

export const queryParamsFactory = (formData, type) => {
	if (type === 'select') {
		return {
			channelId: formData.channel,
			regionId: formData.region,
			agencyId: formData.agency,
			managerLogin: formData.manager,
			sort: ['surname,asc', 'firstName,asc'],
		};
	} else {
		return {
			firstName: formData.firstName,
			surname: formData.surname,
			login: formData.login,
			sellerIn: formData.sellerIn || formData.agencyIn,
			size: REQUEST_SIZE,
			page: 0,
			sort: ['surname,asc', 'firstName,asc'],
		};
	}
};
